<div aria-labelledby="swal2-title" aria-describedby="swal2-content" class="swal2-popup swal2-modal swal2-show" tabindex="-1" role="dialog" aria-live="assertive" aria-modal="true" style="display: flex;">
  <div class="swal2-header">
    <div class="swal2-icon swal2-warning swal2-icon-show" style="display: flex;">
      <div class="swal2-icon-content">!</div>
    </div>
    <h2 class="swal2-title" id="swal2-title" style="display: block;" i18n="@@ChargingStationActiveWarning">Achtung, Ladevorgang ist noch aktiv!</h2>
    <h5 style="text-align: center;" i18n="@@ChargingStationActiveWarningHeader3">Wenn die Ladestation jetzt neugestartet wird, muss der Ladevorgang danach erneut gestartet werden (außer die Ladestation ist auf FreeCharge eingstellt).</h5>
  </div>

  <div class="swal2-actions">
    <div class="swal2-loader"></div>
    <form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)">
      <button type="submit" id="restart_chargingstation" class="btn btn-danger me-2" [disabled]="!formService.form.valid" aria-label="" i18n="@@ConfirmChargingstationWarningResetButton">Ladestation neustarten</button>
    </form>
    <button type="button" id="cancel" class="btn btn-yellow" (click)="onCancelClick()" aria-label="" i18n="@@CancelButton">Abbrechen</button>
  </div>
</div>
